import React, { useEffect, useState } from "react";
import Home from "./components/Home.js";
import NavbarComponent from "./components/NavbarComponent";
import Skills from "./components/Skills";
import Projects from "./components/Projects";
import Footer from "./components/Footer";
import Contact from "./components/Contact";
import BarLoader from "react-spinners/BarLoader";
import Ploygon from "./components/Ploygon";
import AnimatedCursor from "react-animated-cursor";
import Sidebar from "./components/Sidebar";
import About from "./components/About.js";

export default function App() {
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setLoading(true);
    setTimeout(() => {
      setLoading(false);
    }, 1800);
  }, []);

  return (
    <>
      {loading ? (
        <div className="loader-container">
          <h1
            className="has-text-weight-bold"
            style={{ fontSize: "80px", color: "#124559" }}
            data-aos="fade-up"
            data-aos-duration="1000"
          >
            {" "}
            &lt;Mk &frasl; &gt;
          </h1>
          <BarLoader
            width={200}
            height={8}
            color={"hsl(171, 100%, 41%)"}
            className="block"
            data-aos="fade-up"
            data-aos-duration="1000"
          />
        </div>
      ) : (
        <div className="main">
          <AnimatedCursor
            innerSize={10}
            outerSize={10}
            color="0, 255, 217"
            outerAlpha={0.6}
            innerScale={0.3}
            outerScale={5}
          />
          <NavbarComponent />
          <Sidebar />
          <Ploygon />
          <Home />
          <About />
          <Skills />
          <Projects />
          <Contact />
          <Footer />
        </div>
      )}
    </>
  );
}
